<template>
	<div class="p4">
		<core-form-input
			size="small"
			:label="$t('policy_number')"
			componentName="j-base-input-text"
			name="policy_numebr"
			v-model="form.issuerNumber"
		/>

		<!-- Button -->
		<div class="flex xs-left mt6">
			<j-button @click="onSubmit" :isLoading="isLoading">{{
				$t("save")
			}}</j-button>
		</div>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"
import api from "../api"

/**
 * This component is smart
 * It's reposnsible for rendering prepopulated form and updating data via API
 * When update is done it emits event up to the parent
 */
export default {
	components: { CoreFormInput, JButton },

	props: {
		data: {
			type: Object,
			default: () => ({
				issuerNumber: null
			})
		}
	},

	data() {
		return {
			isLoading: false,
			form: {
				issuerNumber: null
			}
		}
	},

	methods: {
		async onSubmit() {
			if (!this.$route.params.id) return

			this.isLoading = true
			const res = await api.updatePolicy({
				policyId: this.$route.params.id,
				updatedPolicy: {
					issuerNumber: this.form.issuerNumber
				}
			})

			// Check errors
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				this.isLoading = false
				return
			}

			this.$emit("updated")
			this.isLoading = false
			this.$modal.hide("updateParticulars")
		}
	},

	created() {
		// Populate form from data prop
		this.form = { ...this.data }
	}
}
</script>